import { createStore } from 'effector';

import type { AuthIdentity, AuthIdentityClient } from './types';

/**
 * User store - server only
 */
export const $userServer = createStore<AuthIdentity>({} as AuthIdentity, {
	sid: '$user-server',
	serialize: 'ignore',
});

/**
 * User store
 */
export const $user = createStore<AuthIdentityClient>({} as AuthIdentityClient, {
	sid: '$user',
});

/**
 * Token store - server only
 */
export const $tokenServer = createStore<string>('', { serialize: 'ignore', sid: '$token-server' });
